import { render, staticRenderFns } from "./addPopUp.vue?vue&type=template&id=40b69fd8&"
import script from "./addPopUp.vue?vue&type=script&lang=js&"
export * from "./addPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b69fd8')) {
      api.createRecord('40b69fd8', component.options)
    } else {
      api.reload('40b69fd8', component.options)
    }
    module.hot.accept("./addPopUp.vue?vue&type=template&id=40b69fd8&", function () {
      api.rerender('40b69fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addPopUp.vue"
export default component.exports